import { Injectable, inject } from '@angular/core';
import { BehaviorSubject, Observable, catchError, filter, switchMap, take, throwError } from 'rxjs';
import { HttpErrorResponse, HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class TokenRefreshService {
  private isRefreshing = false;
  private readonly refreshedTokenSubject = new BehaviorSubject<string | null>(null);

  private readonly authService = inject(AuthService);

  handle401Error(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
    if (this.isRefreshing) {
      return this.refreshedTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) =>
          next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })),
        ),
      );
    }

    this.isRefreshing = true;
    this.refreshedTokenSubject.next(null);

    return this.authService.refresh().pipe(
      switchMap((response) => {
        this.isRefreshing = false;
        this.refreshedTokenSubject.next(response.accessToken);
        return next(
          req.clone({ setHeaders: { Authorization: `Bearer ${response.accessToken}` } }),
        );
      }),
      catchError((refreshError: unknown) => {
        this.isRefreshing = false;
        this.refreshedTokenSubject.next(null);
        return throwError(() => refreshError);
      }),
    );
  }

  reset(): void {
    this.isRefreshing = false;
    this.refreshedTokenSubject.next(null);
  }
}